import * as yup from 'yup';

import { testMaxQuantity } from 'coreOld/yup';

export const pricingFormSchema = yup.object({
  startDate: yup.string().nullable(),
  endDate: yup.string().nullable(),
  priceItems: yup.array().of(
    yup.object({
      minQuantity: yup.string().nullable(),
      maxQuantity: yup
        .string()
        .nullable()
        .test(...testMaxQuantity()),
      discountIncrease: yup.string().nullable(),
      marginReduction: yup.string().nullable(),
    })
  ),
});
